import { useAppStore } from '@/store/store';
import { encodeStateToURL, writeStateToHash } from '@freight-cbm/shared-logic';
import { useState } from 'react';
import { NotificationBanner } from './NotificationBanner';

export function ShareButton() {
  const [copied, setCopied] = useState(false);
  const [banner, setBanner] = useState<{ message: string; type: 'success' | 'error' | 'warning' } | null>(null);

  const handleShare = async () => {
    const state = useAppStore.getState();
    const encoded = encodeStateToURL({
      packages: state.packages.map((p) => ({
        length: p.length,
        width: p.width,
        height: p.height,
        weight: p.weight,
        quantity: p.quantity,
        dimUnit: p.dimUnit,
        weightUnit: p.weightUnit,
      })),
      mode: state.mode,
      ...(state.divisorOverridden ? { dimDivisor: state.dimDivisor } : {}),
    });

    writeStateToHash(encoded);

    const url = window.location.href;
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Fallback: notify user to copy from address bar
      window.location.hash = encoded;
      setBanner({ message: 'URL updated — copy from address bar to share.', type: 'warning' });
    }
  };

  return (
    <div style={{ display: 'inline-flex', flexDirection: 'column', gap: 'var(--space-1)' }}>
      {banner && (
        <NotificationBanner
          message={banner.message}
          type={banner.type}
          onDismiss={() => setBanner(null)}
        />
      )}
      <button type="button" className="btn btn-sm" onClick={handleShare} title="Share calculation via URL">
        {copied ? 'Copied!' : 'Share'}
      </button>
    </div>
  );
}
